'use strict';

var Backbone = require('backbone');
var $ = require('jquery');

export default Backbone.Collection.extend({

  setCurrent: function (language) {
    window.location.href = this.addLangParamToUrl(language);
  },

  getCurrent: function () {
    return $('html').attr('lang');
  },

  addLangParamToUrl: function (language) {
    var url = window.location.href;
    var separator = (url.indexOf('?') === -1) ? '?' : '&';
    var lang = separator + 'lang=' + language;
    var hash = window.location.hash;

    url = url.split('#')[0];

    // remove existing lang parameter before adding it
    if (url.indexOf('?lang') !== -1 || url.indexOf('&lang') !== -1) {
      url = this.removeParam('lang', url);
    }

    url += lang;

    if (hash) {
      url += hash;
    }

    return url;
  },

  removeParam: function (key, url) {
    var newUrl = url.split('?')[0],
        param,
        params = [],
        queryString = (url.indexOf('?') !== -1) ? url.split('?')[1] : '';

    if (queryString !== '') {
      params = queryString.split('&');

      for (var i = params.length - 1; i >= 0; i -= 1) {
        param = params[i].split('=')[0];

        if (param === key) {
          params.splice(i, 1);
        }
      }
      newUrl = newUrl + '?' + params.join('&');
    }

    return newUrl;
  }
});
